import React from 'react';
import classnames from 'classnames';
import gettext from 'js-utils/gettext';
import Button from 'eventbrite_design_system/button/Button';

import { BROWSE_EVENTS_PATH } from '../constants';

const BrowseMoreButton = ({
    showFeaturedOrganizers,
    handleClickBrowseEvents,
}) => {
    const containerClassNames = classnames('eds-align--center', {
        'eds-l-pad-top-4': !showFeaturedOrganizers,
        'user-collection__browse-more-button-container': showFeaturedOrganizers,
    });

    return (
        <div className={containerClassNames} style={{ marginTop: '-24px' }}>
            <Button
                type="link"
                href={BROWSE_EVENTS_PATH}
                onClick={handleClickBrowseEvents}
            >
                {gettext('Browse other events')}
            </Button>
        </div>
    );
};

export default BrowseMoreButton;
